var map = {
	"./TXT.png": "30fb",
	"./audio.png": "d9e9",
	"./compress.png": "dc27",
	"./folder.png": "217f",
	"./pdf.png": "b3c5",
	"./pic.png": "3852",
	"./ppt.png": "08e5",
	"./unknown.png": "c6ed",
	"./video.png": "7b6c",
	"./word.png": "c662",
	"./xls.png": "3c40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e083";